export const isObjectsEqual = (obj1: any, obj2: any, dropFields: string[] = []): boolean => {
  const obj1Copy = { ...obj1 };
  const obj2Copy = { ...obj2 };

  dropFields.forEach((field) => {
    delete obj1Copy[field];
    delete obj2Copy[field];
  });

  return JSON.stringify(obj1Copy) === JSON.stringify(obj2Copy);
};
